// extracted by mini-css-extract-plugin
export default {"form":"v0ZDrajYHOfB7Vhk99_y__form___","select":"tOGHheTaQZDkmJlMYbsK__select___"};